import { getBusinessUnits, getItemCategories, getTenders} from "@/requesters/referentiel";

export const REFERENTIEL_NS = 'ref';

const state = {
    itemCategories: [],
    taxGroups: [],
    taxNames: [],
    tenders: [],
    businessUnits: []
}

const getters = {
    itemCategories(state) {
        return state.itemCategories;
    },
    taxGroups(state) {
        return state.taxGroups;
    },
    taxNames(state) {
        return state.taxNames;
    },
    tenders(state) {
        return state.tenders;
    },
    businessUnits(state) {
        return state.businessUnits;
    }
}

const mutations = {
    updateItemCategories(state, itemCategories) {
        state.itemCategories = itemCategories;
    },
    updateTaxGroups(state, taxGroups) {
        state.taxGroups = taxGroups;
    },
    updateTaxNames(state, taxNames) {
        state.taxNames = taxNames;
    },
    updateTenders(state, tenders) {
        state.tenders = tenders;
    },
    updateBusinessUnits(state, businessUnits) {
        state.businessUnits = businessUnits;
    }
}

const actions = {
    refreshBusinessUnits({commit}) {
        getBusinessUnits()
            .then((stores) => {
                commit('updateBusinessUnits', stores)
            });
    },
    refreshItemCategories({commit}) {
        getItemCategories()
            .then((itemCategories) => {
                commit('updateItemCategories', itemCategories)
            });
    },
    refreshTenders({commit}) {
        getTenders()
            .then((tenders) => {
                commit('updateTenders', tenders)
            });
    },
    refreshTaxGroups({commit}) {
        commit('updateTaxGroups', [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25])
    },
    refreshTaxNames({commit}) {
        commit('updateTaxNames', [
                "DKT:HighTaxRate", "DKT:MiddleTaxRate", "DKT:LowTaxRate", "DKT:SuperLowTaxRate",
                "DKT:ExemptTaxRate", "DKT:NormalTaxRate", "DKT:MediumTaxRate",
                "DKT:SuperLuxuryTaxRate", "DKT:LuxuryPlusTaxRate", "DKT:LuxuryTaxRate", "DKT:AvalaraTaxRate",
                "DKT:AvalaraExemptTaxRate"
            ]
        )
    },
    initReferentiel({dispatch}) {
        dispatch('refreshBusinessUnits');
        dispatch('refreshItemCategories');
        dispatch('refreshTenders');
        dispatch('refreshTaxGroups');
        dispatch('refreshTaxNames');
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
